import { useContext, useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { AuthContext, getUserToken } from "../../contexts/AuthContext";
import Header from "../Header";
import config from "../../config";
import { ListContext } from "../../pages/ListWrapper";
import Error from "../Error";
import { NotificationContext } from "../../contexts/NotificationContext";
import { XMarkIcon } from "@heroicons/react/24/solid";
import ListTranslations from "./ListTranslations";
import ListCityList from "./ListCityList";
import { ModalContext } from "../../contexts/ModalContext";
import { generateId } from "../../util/Random";
import { wrapFetch } from "../../util/Hmac";
import ListMap from "./ListMap";

function ListDetail() {
    const { id } = useParams();
    const navigate = useNavigate();
    const { addNotification } = useContext(NotificationContext);
    const { openModal } = useContext(ModalContext);
    const [list, setList] = useContext(ListContext);
    const authValue = useContext(AuthContext);
    const [error, setError] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);

    async function deleteList() {
        const token = await getUserToken();
        const res = await fetch(`${config.geoid_url_v3}/v3/cms/list/${list.id}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        });

        if (res.status === 200) {
            navigate('/lists');
            addNotification('List was removed successfully', 'SUCCESS');
        } else {
            const result = await res.json();
            addNotification(result.message, 'ERROR');
        }
    }

    useEffect(() => {
        async function getData() {
            try {
                const result = await wrapFetch(`${config.geoid_url_v3}/v3/cms/list/${id}?cb=${generateId(8)}`);

                setList(result);

                document.title = `GeoCMS\u00ae | ${result.name_default}`;
            } catch (error) {
                console.log(error);
                setError(error);
            } finally {
                setIsLoaded(true);
            }
        }

        if (authValue && authValue.user) {
            getData();
        }
    }, [id, setList, authValue]);

    if (error) {
        return (
            <div className="List">
                <Header heading="List" />

                <Error error={error} />
            </div>
        )
    } else if (!isLoaded) {
        return (
            <div className="List">
                <Header heading="List" loading={true} />

                <div className="flex flex-col max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
                    <div className="bg-gray-200 w-full animate-pulse h-64 rounded-lg mb-4"></div>
                </div>
            </div>
        )
    } else if (list) {
        return (
            <div className="List">
                <Header heading={list.name_default}>
                    <button
                        onClick={() => openModal(`You are about to remove ${list.name_default}`, 'Are you sure you want to remove this list and its translations? You can\'t undo this action later.', 'Cancel', 'Remove', () => deleteList())}
                        type="button"
                        className="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-red-300">
                        Remove
                        <XMarkIcon className="ml-1 h-5 w-5" />
                    </button>
                </Header>

                <div className="flex flex-col max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
                    <ListTranslations />

                    <ListCityList list_id={id} />

                    {list.locations && list.locations.length > 0 && <ListMap />}
                </div>
            </div>
        )
    }
}

export default ListDetail;